module.exports = __webpack_public_path__ + "img/lv_failure_4.35f8dec4.png";